var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('h1',{staticClass:"error"},[_vm._v("404")]),_c('div',{staticClass:"page"},[_vm._v("Ooops!!! The page you are looking for is not found")]),_c('router-link',{staticClass:"back-home",attrs:{"to":"/"}},[_vm._v("Back to home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }